import React from 'react';
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  styled,
  tableCellClasses,
} from '@mui/material';
import { WidgetContent } from 'src/components/Widget/types';
import { DashboardDataReceipts } from 'src/api/services/types';
import { getFormattedTimeSpanTitle } from '../../utils';
import { formatNumber, importantCSS } from 'src/viewsUtils';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  borderColor: theme.palette.dividerLight,
  [`&.${tableCellClasses.head}`]: {
    // backgroundColor: theme.palette.common.black,
    // color: theme.palette.common.white,
    opacity: '0.75',
    fontSize: 14,
    borderColor: 'transparent',
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 20,
    paddingTop: theme.spacing(1.375),
    paddingBottom: theme.spacing(1.375),
  },
  '&:first-of-type': {
    width: 'auto',
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:first-of-type': {
    width: 'none',
  },
  letterSpacing: '-0.5px',
}));

const VendorsListContent: WidgetContent<DashboardDataReceipts['vendors']> = ({
  data,
}) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      flex={1}
      width="100%"
      mt={1}
      justifyContent="center"
      alignSelf="flex-start"
    >
      <TableContainer dir="rtl">
        <Table>
          <TableHead>
            <TableRow>
              <StyledTableCell
                padding="none"
                sx={{ pr: ({ spacing }) => spacing(4) }}
                align="right"
              >
                ספק
              </StyledTableCell>
              <StyledTableCell
                sx={{ pr: ({ spacing }) => spacing(1.75) }}
                padding="none"
                align="right"
              >
                סכום
              </StyledTableCell>
              <StyledTableCell
                sx={{ pr: ({ spacing }) => spacing(1.75) }}
                padding="none"
                align="right"
              >
                חשבוניות
              </StyledTableCell>
              <StyledTableCell
                sx={{ pr: ({ spacing }) => spacing(1.75) }}
                padding="none"
                align="right"
              >
                חשבונית אחרונה
              </StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(data ?? []).map((vendor) => (
              <StyledTableRow key={vendor.name}>
                <StyledTableCell
                  sx={{ width: importantCSS('25%') }}
                  align="right"
                >
                  <Box display="flex" flexWrap="nowrap" width="fit-content">
                    <Box
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      minWidth={48}
                    >
                      <Box component="img" src={vendor.logo} height={23} />
                    </Box>
                    <Typography variant="h5" fontSize={20} fontWeight={600}>
                      {vendor.name}
                    </Typography>
                  </Box>
                </StyledTableCell>
                <StyledTableCell
                  align="right"
                  sx={{ width: importantCSS('25%') }}
                >{`${formatNumber(vendor.expenses.total)}${vendor.expenses.unit ?? ''}`}</StyledTableCell>
                <StyledTableCell
                  align="right"
                  sx={{ width: importantCSS('20%') }}
                >
                  {formatNumber(vendor.receipts)}
                </StyledTableCell>
                <StyledTableCell align="right">{`לפני ${getFormattedTimeSpanTitle(vendor.timeSpan, null)}`}</StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default VendorsListContent;
